import { SVGProps, Ref, forwardRef } from 'react';

export const PenOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.375 11.625H3.48l7.502-7.503a2.195 2.195 0 1 0-3.104-3.104L.375 8.52zm8.313-6.693-5.643 5.643h-1.62v-1.62l5.643-5.643zm.742-.743.81-.809a1.145 1.145 0 0 0-1.62-1.62l-.81.81z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PenOutlinedSize12Glyph.displayName = 'PenOutlinedSize12Glyph';
